import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["href"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useCallback, useMemo } from 'react';
import Markdown from "@scentregroup/ui/components/markdown";
import { Box } from '@hub/box';
import { useToken } from '@hub/design-system-base';
import { CoreContainer } from '@hub/core-container';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import { Link } from '@hub/link';
import { Button } from '@hub/button';
// useMobileBreakpoint looks unavoidable here due to the checkReadMore logic
// eslint-disable-next-line no-restricted-syntax
import useMobileBreakpoint from '@scentregroup/shared/helpers/use-mobile-breakpoint';
import { CloudinaryImage, IMAGE_SIZES_HERO, IMAGE_SIZES_THUMBNAIL } from '../cloudinary-image';
import { useSupportingColors } from '../../hooks/use-supporting-colors';
import Breadcrumbs from '../breadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_INITIAL_MOBILE_LINES_HEIGHT = 74;
const MAX_INITIAL_DESKTOP_LINES_HEIGHT = 272;
const MaybeLink = _ref => {
  let {
      href
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return href ? /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
    href: href
  }, rest), {}, {
    "data-id": "store-header_index_MaybeLink_Link"
  })) : /*#__PURE__*/_jsx(_Fragment, {
    children: rest.children
  });
};
export const StoreHeader = _ref2 => {
  let {
    retailerLogo,
    title,
    url = '',
    scrollToId = '',
    subTitle = '',
    longDescription: description,
    heroImage,
    supportingColor,
    nationalStorefrontUrl,
    breadcrumbs,
    enableH1Heading
  } = _ref2;
  const squareImagePadding = useToken('space', 'spacing-md');
  const {
    supportingForegroundColor,
    supportingBackgroundColor
  } = useSupportingColors(supportingColor);
  const isMobile = useMobileBreakpoint();
  const {
    0: displayReadMore,
    1: setDisplayReadMore
  } = useState(false);
  const {
    0: readmore,
    1: setReadMore
  } = useState(true);
  const descriptionMaxTextHeight = useMemo(() => isMobile ? MAX_INITIAL_MOBILE_LINES_HEIGHT : MAX_INITIAL_DESKTOP_LINES_HEIGHT, [isMobile]);
  const checkReadMore = useCallback(element => {
    if (!element) {
      return;
    }
    setDisplayReadMore(descriptionMaxTextHeight < element.scrollHeight);
  }, [descriptionMaxTextHeight]);
  const descriptionMaxHeight = useMemo(() => readmore ? "".concat(descriptionMaxTextHeight, "px") : 'unset', [readmore, descriptionMaxTextHeight]);
  return /*#__PURE__*/_jsxs(CoreContainer, {
    isMobileFullWidth: true,
    "data-id": "store-header_index_MaybeLink_CoreContainer",
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        marginTop: ['spacing-sm', null, 'spacing-none'],
        marginBottom: ['spacing-sm', null, 'spacing-md'],
        marginLeft: ['spacing-md', 'spacing-md', 'spacing-none']
      },
      "data-id": "store-header_index_MaybeLink_CoreContainer_Box",
      children: /*#__PURE__*/_jsx(Breadcrumbs, {
        breadcrumbs: breadcrumbs,
        "data-id": "store-header_index_MaybeLink_Box_Breadcrumbs"
      })
    }), /*#__PURE__*/_jsxs(Stack, {
      gap: ['spacing-md', 'spacing-md', 'spacing-3xl'],
      direction: ['column', 'column', 'row'],
      shouldWrapChildren: false,
      flexGrow: 0,
      sx: {
        alignItems: ['left', 'left', 'top'],
        backgroundColor: supportingBackgroundColor,
        padding: 'spacing-md'
      },
      "data-id": "store-header_index_MaybeLink_CoreContainer_Stack",
      children: [/*#__PURE__*/_jsxs(Stack, {
        shouldWrapChildren: false,
        sx: {
          color: supportingForegroundColor,
          flexBasis: [null, null, '70%']
        },
        gap: "spacing-md",
        "data-id": "store-header_index_MaybeLink_Stack_Stack_5",
        children: [/*#__PURE__*/_jsxs(Stack, {
          shouldWrapChildren: false,
          direction: "row",
          gap: "spacing-md",
          align: "center",
          "data-id": "store-header_index_MaybeLink_Stack_Stack_6",
          children: [retailerLogo && /*#__PURE__*/_jsx(CloudinaryImage, {
            ratio: "1",
            sx: {
              minWidth: 'size-12',
              maxWidth: 'size-12'
            },
            imageSetOrImage: {
              type: 'SQUARE',
              url: retailerLogo
            },
            "aria-labelledby": title,
            resizeMode: "pad",
            sizes: IMAGE_SIZES_THUMBNAIL,
            loadingMode: "eager",
            "data-id": "store-header_index_MaybeLink_CloudinaryImage"
          }), /*#__PURE__*/_jsxs(Box, {
            "data-id": "store-header_index_MaybeLink_Stack_Box",
            children: [/*#__PURE__*/_jsx(MaybeLink, {
              href: nationalStorefrontUrl,
              "data-id": "store-header_index_Box_MaybeLink",
              children: /*#__PURE__*/_jsx(Text, {
                isBodyText: true,
                as: enableH1Heading ? 'h1' : 'h3',
                fontSize: ['font-h4', 'font-h4', 'font-h3'],
                tone: "strong",
                "data-id": "store-header_index_MaybeLink_Text",
                children: title
              })
            }), url || scrollToId ? /*#__PURE__*/_jsx(Link, {
              hasUnderline: true,
              href: url || "#".concat(scrollToId),
              onClick: e => {
                if (scrollToId) {
                  var _document;
                  e.preventDefault();
                  (_document = document) === null || _document === void 0 || (_document = _document.getElementById(scrollToId)) === null || _document === void 0 || _document.scrollIntoView({
                    behavior: 'smooth'
                  });
                }
              },
              "data-id": "store-header_index_MaybeLink_Link",
              children: subTitle && /*#__PURE__*/_jsx(Text, {
                "data-id": "store-header_index_MaybeLink_Text",
                children: subTitle
              })
            }) : subTitle && /*#__PURE__*/_jsx(Text, {
              "data-id": "store-header_index_MaybeLink_Text_13",
              children: subTitle
            })]
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          "data-id": "store-header_index_MaybeLink_Stack_Box",
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              maxHeight: descriptionMaxHeight,
              overflow: 'hidden',
              lineHeight: 'base'
            },
            ref: checkReadMore,
            "data-id": "store-header_index_MaybeLink_Box_Box_15",
            children: /*#__PURE__*/_jsx(Markdown, {
              content: description,
              "data-id": "store-header_index_MaybeLink_Box_Markdown"
            })
          }), displayReadMore && /*#__PURE__*/_jsx(Button, {
            sx: {
              textDecoration: 'underline',
              fontWeight: 'normal',
              padding: 'spacing-none',
              height: 'spacing-md',
              textTransform: 'none',
              color: supportingForegroundColor
            },
            variant: "link",
            onClick: () => {
              setReadMore(!readmore);
            },
            "data-id": "store-header_index_MaybeLink_Button",
            children: readmore ? 'See all' : 'See less'
          })]
        })]
      }), heroImage && /*#__PURE__*/_jsx(Box, {
        sx: {
          flexBasis: '30%',
          minWidth: "calc((100% / (21 / 9)) - (2 * ".concat(squareImagePadding, "))")
        },
        "data-id": "store-header_index_MaybeLink_Box",
        children: /*#__PURE__*/_jsx(CloudinaryImage, {
          ratio: "1",
          imageSetOrImage: {
            url: heroImage,
            type: 'WIDE'
          },
          sizes: IMAGE_SIZES_HERO,
          loadingMode: "eager",
          "data-id": "store-header_index_MaybeLink_Box_CloudinaryImage"
        })
      })]
    })]
  });
};